var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSamochodPremium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 242.42 86.55",
    width: 90,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .d {\r\n        fill: none;\r\n        stroke-linecap: round;\r\n        stroke-miterlimit: 10;\r\n        stroke-width: 7.93px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "d",
    stroke: "#000",
    cx: 39.8,
    cy: 61.44,
    r: 21.15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    stroke: "#000",
    cx: 185.22,
    cy: 61.44,
    r: 21.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    stroke: "#000",
    x1: 74.29,
    y1: 73.68,
    x2: 167.98,
    y2: 73.68
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    stroke: "#000",
    d: "M203.83,73.68h14.59c11.37,0,20.46-1.56,20.02-10.65-.44-9.09-12.42-28.17-54.57-31.94,0,0-29.28-18.19-57.67-18.63s-57.9,10.2-71.87,13.53c-13.98,3.33-40.82,7.76-50.35,2.88"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    stroke: "#000",
    x1: 3.97,
    y1: 43.76,
    x2: 3.97,
    y2: 54.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    stroke: "#000",
    x1: 3.97,
    y1: 15.06,
    x2: 39.8,
    y2: 3.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    stroke: "#000",
    x1: 21.88,
    y1: 9.51,
    x2: 29.59,
    y2: 20.31
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    stroke: "#000",
    d: "M75,20.31s8.13,13.09,20.9,13.09h61.73"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSamochodPremium);
export default __webpack_public_path__ + "static/media/samochod_premium.f5f0ac0137756aea3a18fb9343d8b8d3.svg";
export { ForwardRef as ReactComponent };